import { useState, useEffect } from "react";
import "./popup.css";
import { useNavigate } from "react-router-dom";
import { BsPatchCheck } from "react-icons/bs";

export default function Popup({ onClose }) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 400);
  };

  const handleNavigate = () => {
    navigate("/aadhaar-verification");
  };

  return (
    <section className={`popup_container ${show ? "show" : ""}`}>
      <div className="popup_overlay" onClick={() => setShow(false)} />

      <div className="popup_section">
        <div className="popup_content">
          <h2>Verify Your Account</h2>
          {/* <p>Please verify your identity to increase your post reach.</p> */}
          <p>Next, verify to boost credibility and trust. Verify your profile to get <BsPatchCheck/> and to increase post reach boost by 50%...</p>
        </div>

        <div className="popup_actions">
          <button className="verify-now" onClick={handleNavigate}>
            Verify Now
          </button>
          
          <button className="btn_primary" onClick={handleClose}>
            Not Now
          </button>
        </div>
      </div>
    </section>
  );
}
